import { PRIVATE_URIS } from '../constants/privateURIs.constants';

/**
 * Builds the per-post Story Analysis route from its PRIVATE_URIS template,
 * keeping the '/post/:postId/analysis' shape in a single source of truth.
 */
export function postAnalysisPath(postId: string): string {
  return PRIVATE_URIS.POST_ANALYSIS.replace(':postId', postId);
}
